function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "m263.621094 401.777344h116.152344c19.472656 0 35.773437-14.765625 37.695312-34.144532l13.917969-140.3125c6.433593-64.859374-44.511719-121.105468-109.691407-121.105468-65.175781 0-116.121093 56.246094-109.6875 121.105468l13.914063 140.3125c1.921875 19.378907 18.226563 34.144532 37.699219 34.144532zm0 0",
  fill: "#627687"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "m423.148438 245.441406 3.484374-26.25c.5625-4.230468-2.410156-8.117187-6.640624-8.675781-4.226563-.5625-8.113282 2.410156-8.675782 6.640625l-3.757812 28.285156zm0 0",
  fill: "#455e6d"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "m431.027344 453.433594v48.265625c0 5.6875-4.613282 10.300781-10.300782 10.300781h-208.363281v-58.566406c0-31.058594 16.945313-58.132813 42.082031-72.511719 1.171876-.671875 2.359376-1.320313 3.5625-1.929687 11.355469-5.796876 24.210938-9.054688 37.828126-9.054688h51.707031c15.367187 0 29.78125 4.164062 42.152343 11.414062 24.726563 14.496094 41.332032 41.332032 41.332032 72.082032zm0 0",
  fill: "#3a82d0"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "m269.445312 418.265625v83.433594c0 3.707031-.898437 7.210937-2.484374 10.300781h-54.597657v-58.566406c0-31.058594 16.945313-58.132813 42.082031-72.511719 1.175782-.671875 2.359376-1.320313 3.5625-1.929687 7.242188 11.363281 11.4375 24.839843 11.4375 39.273437zm0 0",
  fill: "#0d73ce"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "m431.03125 453.429688v48.269531c0 5.6875-4.613281 10.300781-10.304688 10.300781h-7.382812v-58.570312c0-30.746094-16.605469-57.585938-41.332031-72.078126-12.375-7.253906-26.78125-11.414062-42.152344-11.414062h17.683594c15.371093 0 29.777343 4.160156 42.152343 11.414062 24.726563 14.492188 41.335938 41.332032 41.335938 72.078126zm0 0",
  fill: "#0d73ce"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "m394.878906 457.78125v54.21875h-146.367187v-54.21875s8.527343-2.59375 20.933593-3.039062c14.574219-.523438 34.5 1.925781 52.25 15.050781 32.882813-24.289063 73.183594-12.011719 73.183594-12.011719zm0 0",
  fill: "#ebeef2"
});

var _ref8 = /*#__PURE__*/React.createElement("g", {
  fill: "#d3d8df"
}, /*#__PURE__*/React.createElement("path", {
  d: "m269.445312 454.742188v46.957031c0 3.707031-.898437 7.210937-2.484374 10.300781h-18.449219v-54.21875s8.527343-2.597656 20.933593-3.039062zm0 0"
}), /*#__PURE__*/React.createElement("path", {
  d: "m363.226562 462.722656c-4.269531 0-7.726562-3.457031-7.726562-7.726562v-77.363282c0-4.265624 3.457031-7.726562 7.726562-7.726562 4.265626 0 7.726563 3.460938 7.726563 7.726562v77.363282c0 4.269531-3.460937 7.726562-7.726563 7.726562zm0 0"
}), /*#__PURE__*/React.createElement("path", {
  d: "m280.167969 462.722656c-4.269531 0-7.726563-3.457031-7.726563-7.726562v-77.363282c0-4.265624 3.460938-7.726562 7.726563-7.726562s7.726562 3.460938 7.726562 7.726562v77.363282c0 4.269531-3.460937 7.726562-7.726562 7.726562zm0 0"
}));

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "m321.695312 401.777344c-10.644531 0-19.273437-8.628906-19.273437-19.273438v-54.066406h38.546875v54.066406c0 10.644532-8.628906 19.273438-19.273438 19.273438zm0 0",
  fill: "#f8c298"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "m435.035156 263.3125c0 14.332031-11.621094 25.949219-25.949218 25.949219-14.332032 0-25.949219-11.617188-25.949219-25.949219 0-14.328125 11.617187-25.949219 25.949219-25.949219 14.328124 0 25.949218 11.621094 25.949218 25.949219zm0 0",
  fill: "#f8c298"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "m260.257812 263.3125c0 14.332031-11.617187 25.949219-25.949218 25.949219-14.332032 0-25.949219-11.617188-25.949219-25.949219 0-14.328125 11.617187-25.949219 25.949219-25.949219 14.332031 0 25.949218 11.621094 25.949218 25.949219zm0 0",
  fill: "#f8c298"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "m239.933594 189.972656 12.363281 98.984375c4.375 35 34.125 61.265625 69.398437 61.265625 35.273438 0 65.027344-26.265625 69.398438-61.265625l12.363281-98.984375zm0 0",
  fill: "#ffd6c0"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "m283.710938 269.554688c-4.171876 0-7.605469-3.320313-7.71875-7.515626l-.113282-4.113281c-.117187-4.265625 3.246094-7.820312 7.511719-7.9375 4.273437-.113281 7.816406 3.246094 7.933594 7.515625l.113281 4.113282c.117188 4.265624-3.246094 7.816406-7.511719 7.933593-.074219.003907-.144531.003907-.214843.003907zm0 0",
  fill: "#455e6d"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "m359.789062 269.554688c-4.171874 0-7.609374-3.324219-7.71875-7.519532l-.113281-4.113281c-.117187-4.265625 3.25-7.816406 7.511719-7.933594h.214844c4.167968 0 7.605468 3.320313 7.71875 7.515625l.113281 4.113282c.113281 4.265624-3.25 7.816406-7.515625 7.933593-.070312.003907-.140625.003907-.210938.003907zm0 0",
  fill: "#455e6d"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "m321.695312 306.007812c-11.589843 0-22.570312-5.613281-29.378906-15.019531-2.503906-3.457031-1.730468-8.285156 1.722656-10.789062 3.457032-2.503907 8.289063-1.730469 10.789063 1.726562 3.914063 5.402344 10.21875 8.628907 16.867187 8.628907 6.648438 0 12.957032-3.226563 16.867188-8.628907 2.503906-3.457031 7.335938-4.226562 10.789062-1.726562 3.457032 2.503906 4.230469 7.332031 1.726563 10.789062-6.808594 9.40625-17.792969 15.019531-29.382813 15.019531zm0 0",
  fill: "#ed7a98"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "m402.605469 443.597656v68.402344h-15.453125v-68.402344c0-4.265625 3.460937-7.726562 7.726562-7.726562s7.726563 3.460937 7.726563 7.726562zm0 0",
  fill: "#0d73ce"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "m227.3125 180.449219v28.554687s53.515625 19.042969 92.0625-16.25c0 0 14.800781 47.058594 78.484375 56.757813 4.867187.742187 9.398437-2.65625 10.046875-7.53125l8.175781-61.53125zm0 0",
  fill: "#627687"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "m373.820312 288.054688c0 3.875-3.140624 7.015624-7.015624 7.015624-3.871094 0-7.011719-3.140624-7.011719-7.015624 0-3.871094 3.140625-7.011719 7.011719-7.011719 3.875 0 7.015624 3.140625 7.015624 7.011719zm0 0",
  fill: "#ed7a98"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "m283.601562 288.054688c0 3.875-3.140624 7.015624-7.015624 7.015624-3.871094 0-7.011719-3.140624-7.011719-7.015624 0-3.871094 3.140625-7.011719 7.011719-7.011719 3.875 0 7.015624 3.140625 7.015624 7.011719zm0 0",
  fill: "#ed7a98"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "m257.082031 418.265625v83.433594c0 5.6875-4.613281 10.300781-10.300781 10.300781h-236.480469c-5.6875 0-10.300781-4.613281-10.300781-10.300781v-83.433594c0-33.667969 27.292969-60.957031 60.957031-60.957031h135.167969c33.667969 0 60.957031 27.289062 60.957031 60.957031zm0 0",
  fill: "#5f9eeb"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "m84.644531 357.304688h90.707031v154.695312h-90.707031zm0 0",
  fill: "#ebeef2"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "m257.074219 418.25v83.445312c0 5.691407-4.609375 10.300782-10.300781 10.300782h-10.46875v-93.734375c0-33.660157-27.296876-60.957031-60.957032-60.957031h20.78125c33.660156 0 60.945313 27.289062 60.945313 60.945312zm0 0",
  fill: "#3a82d0"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "m129.996094 391.628906c-11.472656 0-20.773438-9.304687-20.773438-20.777344v-58.28125h41.550782v58.28125c0 11.472657-9.300782 20.777344-20.777344 20.777344zm0 0",
  fill: "#e39f6e"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  d: "m20.082031 231.296875h219.832031l5.796876-28.28125c15.015624-73.25-40.941407-141.84375-115.710938-141.84375-74.773438 0-130.730469 68.59375-115.714844 141.84375zm0 0",
  fill: "#455e6d"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  d: "m252.175781 242.363281c0 15.449219-12.523437 27.976563-27.972656 27.976563s-27.972656-12.527344-27.972656-27.976563 12.523437-27.972656 27.972656-27.972656 27.972656 12.523437 27.972656 27.972656zm0 0",
  fill: "#e39f6e"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  d: "m63.765625 242.363281c0 15.449219-12.523437 27.976563-27.972656 27.976563s-27.972657-12.527344-27.972657-27.976563 12.523438-27.972656 27.972657-27.972656 27.972656 12.523437 27.972656 27.972656zm0 0",
  fill: "#e39f6e"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  d: "m129.996094 336.054688c-38.023438 0-70.097656-28.316407-74.808594-66.046876l-13.917969-111.40625h177.453125l-13.914062 111.40625c-4.714844 37.730469-36.785156 66.046876-74.8125 66.046876zm0 0",
  fill: "#f8c298"
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  d: "m89.046875 248.488281c-4.167969 0-7.605469-3.320312-7.71875-7.515625l-.121094-4.433594c-.117187-4.265624 3.246094-7.816406 7.511719-7.933593 4.257812-.113281 7.820312 3.246093 7.9375 7.511719l.121094 4.4375c.113281 4.265624-3.25 7.816406-7.515625 7.933593-.070313 0-.144531 0-.214844 0zm0 0",
  fill: "#355260"
});

var _ref29 = /*#__PURE__*/React.createElement("path", {
  d: "m171.0625 248.488281c-4.171875 0-7.605469-3.320312-7.71875-7.511719l-.125-4.433593c-.117188-4.265625 3.246094-7.820313 7.511719-7.9375 4.292969-.109375 7.820312 3.246093 7.9375 7.511719l.121093 4.433593c.117188 4.265625-3.246093 7.816407-7.511718 7.9375-.070313 0-.144532 0-.214844 0zm0 0",
  fill: "#355260"
});

var _ref30 = /*#__PURE__*/React.createElement("path", {
  d: "m130 287.785156c-12.300781 0-23.960938-5.957031-31.1875-15.9375-2.503906-3.457031-1.730469-8.289062 1.726562-10.789062 3.457032-2.503906 8.285157-1.730469 10.789063 1.722656 4.332031 5.980469 11.308594 9.554688 18.671875 9.554688 7.359375 0 14.339844-3.570313 18.667969-9.554688 2.503906-3.453125 7.335937-4.226562 10.789062-1.722656 3.457031 2.5 4.230469 7.332031 1.726563 10.789062-7.226563 9.980469-18.886719 15.9375-31.183594 15.9375zm0 0",
  fill: "#e39f6e"
});

var _ref31 = /*#__PURE__*/React.createElement("path", {
  d: "m57.371094 436.714844v75.285156h-15.453125v-75.285156c0-4.265625 3.460937-7.726563 7.726562-7.726563s7.726563 3.460938 7.726563 7.726563zm0 0",
  fill: "#3a82d0"
});

var _ref32 = /*#__PURE__*/React.createElement("path", {
  d: "m215.152344 436.714844v75.285156h-15.453125v-75.285156c0-4.265625 3.460937-7.726563 7.726562-7.726563s7.726563 3.460938 7.726563 7.726563zm0 0",
  fill: "#3a82d0"
});

var _ref33 = /*#__PURE__*/React.createElement("path", {
  d: "m25.503906 166.304688s18.761719 18.609374 69.285156 19.960937c3.199219.085937 5.847657-2.480469 5.847657-5.683594v-7.496093s18.363281 12.046874 57.269531 13.175781c3.207031.089843 5.871094-2.472657 5.871094-5.683594v-4.253906s15.136718 9.238281 60.503906 9.972656c3.175781.050781 5.789062-2.503906 5.789062-5.683594v-31.519531h-204.566406zm0 0",
  fill: "#455e6d"
});

var _ref34 = /*#__PURE__*/React.createElement("path", {
  d: "m224.378906 194.023438c-.074218 0-.148437 0-.222656 0-27.722656-.449219-44.757812-3.988282-54.316406-6.96875-.632813 1.140624-1.4375 2.195312-2.398438 3.132812-2.59375 2.515625-6.167968 3.898438-9.761718 3.792969-23.542969-.679688-40.101563-5.242188-50.027344-9.058594-.667969 1.964844-1.800782 3.761719-3.335938 5.257813-2.625 2.554687-6.101562 3.890624-9.753906 3.808593-32.367188-.871093-52.660156-8.554687-63.980469-14.84375-3.730469-2.074219-5.074219-6.777343-3-10.507812 2.070313-3.730469 6.773438-5.074219 10.503907-3 9.582031 5.324219 26.804687 11.800781 54.828124 12.835937v-5.390625c0-2.839843 1.554688-5.449219 4.054688-6.800781 2.496094-1.347656 5.535156-1.21875 7.910156.339844.125.082031 16.773438 10.457031 51.171875 11.839844v-2.140626c0-2.835937 1.453125-5.503906 3.949219-6.855468 2.472656-1.339844 5.386719-1.289063 7.75.226562.953125.511719 15.542969 7.960938 54.59375 8.839844v-12.230469c0-4.265625 3.460938-7.726562 7.726562-7.726562 4.269532 0 7.726563 3.460937 7.726563 7.726562v14.3125c0 3.617188-1.421875 7.011719-4.003906 9.550781-2.53125 2.496094-5.867188 3.859376-9.414063 3.859376zm0 0",
  fill: "#355260"
});

var _ref35 = /*#__PURE__*/React.createElement("path", {
  d: "m467.839844 0h-156.664063c-7.074219 0-12.804687 5.734375-12.804687 12.804688v102.519531c0 7.074219 5.730468 12.808593 12.804687 12.808593h27.539063l11.707031 15.132813c5.128906 6.628906 15.132813 6.628906 20.257813 0l11.707031-15.132813h85.453125c7.074218 0 12.804687-5.734374 12.804687-12.808593v-102.519531c.003907-7.070313-5.730469-12.804688-12.804687-12.804688zm0 0",
  fill: "#eb5777"
});

var _ref36 = /*#__PURE__*/React.createElement("path", {
  d: "m385.054688 54.839844h-7v-7c0-4.269532-3.457032-7.726563-7.726563-7.726563-4.265625 0-7.726563 3.457031-7.726563 7.726563v7h-6.996093c-4.269531 0-7.726563 3.457031-7.726563 7.726562 0 4.265625 3.457032 7.722656 7.726563 7.722656h6.996093v7c0 4.269532 3.460938 7.726563 7.726563 7.726563 4.269531 0 7.726563-3.457031 7.726563-7.726563v-7h7c4.269531 0 7.726562-3.457031 7.726562-7.722656 0-4.269531-3.457031-7.726562-7.726562-7.726562zm0 0",
  fill: "#ebeef2"
});

var _ref37 = /*#__PURE__*/React.createElement("path", {
  d: "m431.359375 79.808594h-1.65625v-42.214844c0-2.699219-1.410156-5.207031-3.71875-6.605469-2.3125-1.402343-5.1875-1.492187-7.578125-.242187l-9.820312 5.121094c-3.78125 1.972656-5.25 6.640624-3.277344 10.421874 1.722656 3.304688 5.496094 4.839844 8.945312 3.867188v29.652344h-1.65625c-4.265625 0-7.726562 3.460937-7.726562 7.726562 0 4.269532 3.460937 7.726563 7.726562 7.726563h18.761719c4.269531 0 7.726563-3.457031 7.726563-7.726563 0-4.265625-3.460938-7.726562-7.726563-7.726562zm0 0",
  fill: "#ebeef2"
});

var SvgRequest = function SvgRequest(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "512pt",
    viewBox: "-16 0 512 512.001",
    width: "512pt",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRequest, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/request.0235a4b3.svg";
export { ForwardRef as ReactComponent };